<template>
  <div class="mobile-menu">
    <a id="getty-logo" href="http://www.getty.edu" title="The J. Paul Getty">
      <span class="icon-getty-logo is-pulled-left"></span>
    </a>
    <h1><a href="http://www.getty.edu">The Getty</a></h1>
    <span class="icon-getty-hamburger is-large" @click="toggleMenu()"></span>
  </div>
</template>

<script>
export default {
  name: "HeaderMobile",
  data() {
    return {
      toggled: false
    };
  },
  props: {
    info: Object
  },
  methods: {
    toggleMenu() {
      this.toggled = !this.toggled;
      this.$parent.$emit("update:toggle:menu");
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-menu {
  background: $black;
  color: $white;
  display: flex;
  font-family: APHont, "Neue Helvetica W01", Arial, "Microsoft Yahei",
    "微软雅黑", STXihei, "华文细黑", sans-serif;
  height: 40px;
  justify-content: space-between;
  line-height: 40px;
  a {
    color: $white;
  }
  .icon-getty-logo {
    color: $white;
    &:before {
      font-size: 2.7em;
      padding-left: 0;
    }
  }
  .icon-getty-hamburger {
    font-size: 1.33333em;
    margin-top: 0.5em;
    width: 30px;
  }
  h1 {
    font-family: "APHont", "Syntax Next W01", "Neue Helvetica W01", Helvetica,
      Arial, sans-serif;
    font-weight: 500;
    font-size: 1.2em;
    text-align: center;
  }
}
</style>
